module.exports = __webpack_public_path__ + "static/img/francesca_pureblood.d95e17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/francesca_pureblood.png
// module id = Lq/l
// module chunks = 0